import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { useSegmentContext } from '../../../widgets/FlightsManager/Segment/SegmentManager/Context';
import { useSlideContext } from '../../SlideManager';
import { displayFaresInCalendar } from '../../../redux/currentSearch/selectors';
import { CalendarTypeProp } from '../../../models';
import { ConnectedFaresRenderInner } from './FaresRenderInner';

export const FaresProviderRender = ({ date, calendarType, isDayDisabled, displayFaresInCalendar }) => {
    const { entered } = useSlideContext();
    const { segment } = useSegmentContext();

    if (!displayFaresInCalendar) {
        return <React.Fragment />;
    }

    return (
        <ConnectedFaresRenderInner
            entered={entered}
            isDayDisabled={isDayDisabled}
            date={date}
            calendarType={calendarType}
            segmentId={segment.id}
        />
    );
};

FaresProviderRender.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    calendarType: CalendarTypeProp.isRequired,
    displayFaresInCalendar: PropTypes.bool.isRequired,
    isDayDisabled: PropTypes.bool.isRequired,
};

const mapStateToPropsSelectorRender = createStructuredSelector({
    displayFaresInCalendar,
});

export const ConnectedFaresProviderRender = connect(mapStateToPropsSelectorRender)(FaresProviderRender);
